import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsCaretDownFill } from "react-icons/bs";
import { FaBars } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import { fetchThemeSetting } from "../../redux/getReducer/getthemeSlice";
// import "../CSS/header.css"; 
import { BsChevronDown } from "react-icons/bs";
import { Accordion } from "react-bootstrap";
import Language from "../Home/Components/Language";
import i18next from "i18next";
import { FiRepeat } from "react-icons/fi";

const Header = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const currentLanguageCode = Cookies.get("i18next") || "en"; 
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchThemeSetting());
  }, [dispatch]);

  return (
    <>
      {/* Logo Section */}
      <div className="new-logo-area">
        <Link to="/" className="new-logo-link">
          <img src={t("logo")} alt="logo" />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <nav className="new-nav-menu">
        <Link to="/" className="new-nav-link">
          {t("home")}
        </Link>
        {/* <Link to="/about" className="new-nav-link">
          {t("about")}
        </Link> */}

        {/* Statistics Dropdown */}
        <div className="new-dropdown-container">
          <div className="new-nav-link new-drop-trigger">
            {t("statistics")} 
            <BsCaretDownFill />
          </div>
          <div className="new-dropdown-content">
            <Link to="/atozreports">{t("AZReport")}</Link>
            <Link to="/hotform">{t("Hot Form")}</Link>
            <Link to="/querytool">{t("Querytool")}</Link>
            <Link to="/trainerstatistics">{t("Trainer Statistics")}</Link>
            <Link to="/ownerstatistics">{t("Owner Statistics")}</Link>
            <Link to="/jockeystatistics">{t("Jockey Statistics")}</Link>
            <Link to="/horsestatistics">{t("Horse Statistics")}</Link>
            <Link to="/trainerjockeycombo">{t("Trainer Jockey Combo")}</Link>
            <Link to="/SireSnippets" style={{border: 'none'}}>{t("Sire Snippets")}</Link>
          </div>
        </div>

        {/* <Link to="/racecards" className="new-nav-link">{t("race_card")}</Link> */}
        <Link to="/result" className="new-nav-link">{t("result")}</Link>
        {/* <Link to="/racecourses" className="new-nav-link">{t("race_course")}</Link> */}
        <Link to="/competition" className="new-nav-link">{t("competition")}</Link>
        
        <a href="https://silk.saddlebattles.com/" className="new-nav-link" target="_blank" rel="noopener noreferrer">
          {t("Owner Silk")}
        </a>

        <div className="new-nav-link new-ar-icon-style" onClick={() => {i18next.changeLanguage(currentLanguageCode === 'en' ? 'ar' : 'en');}}>
          {currentLanguageCode} <FiRepeat /> 
        </div> 
      </nav>

      {/* Mobile Bar Icon */}
      <div className="mobilemenu_icon d-lg-none">
         <FaBars onClick={() => setShow(!show)} style={{color: 'white', cursor: 'pointer'}} />
      </div>

      {/* --- MOBILE MENU SECTION --- */}
      <div className="mobilemenu">
        {show && (
          <Fade top duration={300} distance="10px">
            <div className="mobiledropdown">
              <Link to="/" className="LinkStyle">
                <p onClick={() => setShow(false)}>{t("home")}</p>
              </Link>
              {/* <Link to="/about" className="LinkStyle">
                <p onClick={() => setShow(false)}>{t("about")}</p>
              </Link> */}

              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                   
                     <div className="custom-mobile-accordion-header">
                        <span>{t("statistics")}</span>
                        <BsChevronDown />
                     </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Link to="/atozreports"><p onClick={() => setShow(false)}>{t("AZReport")}</p></Link>
                    <Link to="/hotform"><p onClick={() => setShow(false)}>{t("Hot Form")}</p></Link>
                    <Link to="/querytool"><p onClick={() => setShow(false)}>{t("Querytool")}</p></Link>
                    <Link to="/trainerstatistics"><p onClick={() => setShow(false)}>{t("Trainer Statistics")}</p></Link>
                    <Link to="/jockeystatistics"><p onClick={() => setShow(false)}>{t("Jockey Statistics")}</p></Link>
                    <Link to="/horsestatistics"><p onClick={() => setShow(false)}>{t("Horse Statistics")}</p></Link>
                    <Link to="/trainerjockeycombo"><p onClick={() => setShow(false)}>{t("Trainer Jockey Combo")}</p></Link>
                    <Link to="/SireSnippets"><p onClick={() => setShow(false)}>{t("Sire Snippets")}</p></Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* <Link to="/racecards" className="LinkStyle"><p onClick={() => setShow(false)}>{t("race_card")}</p></Link> */}
              <Link to="/result" className="LinkStyle"><p onClick={() => setShow(false)}>{t("result")}</p></Link>
              {/* <Link to="/racecourses" className="LinkStyle"><p onClick={() => setShow(false)}>{t("race_course")}</p></Link> */}
              <Link to="/competition" className="LinkStyle"><p onClick={() => setShow(false)}>{t("competition")}</p></Link>
              <a href="https://silk.saddlebattles.com/" target="_blank" rel="noopener noreferrer" className="LinkStyle">
                <p>{t("Owner Silk")}</p>
              </a>
              <Link to="/login" className="LinkStyle"><p onClick={() => setShow(false)}>{t("Login")}</p></Link>
              
              <div className="LinkStyle" onClick={() => {
                  i18next.changeLanguage(currentLanguageCode === 'en' ? 'ar' : 'en');
                  setShow(false);
                }}>
                <p>{currentLanguageCode} <FiRepeat /></p>
              </div> 
            </div>
          </Fade>
        )}
      </div>
    </>
  );
};
export default Header;
